import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Api from './Api';
import './SSoft_Solutions_Detail_Card.css';

function SSoft_Solutions_Detail_Card() {
  const [sectionItems, setSectionItems] = useState([]);
  const [titleHeightCheck, setTitleHeightCheck] = useState(false)
  const activeLang = useSelector((state) => state.content.activeLanguage);

  const heightDetect = useRef([]);

  useEffect(() => {
    return () => {
      heightDetect.current = [];
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const api = new Api();
        const sectionResponse = await api.getSectionDetail({ language: activeLang });
        const { widget_contents } = sectionResponse.data?.results[0]?.widgets[0];

        setSectionItems(widget_contents);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [activeLang]);
  
  // useEffect(() => {
  //   if (sectionItems.length !== 0 && heightDetect.current.length !== 0) {
  //     const findUniqueHeight = heightDetect.current.some((data) => data.clientHeight > 65);
  //     if (findUniqueHeight) {
  //       setTitleHeightCheck(true);
  //     }
  //   }
  // }, [activeLang, sectionItems]);

  useEffect(() => {
    if(sectionItems.length > 0){
      const cek = sectionItems.some((data) => data?.article_language?.title.length > 30)

      if (cek === true) {
        setTitleHeightCheck(true)
      }
    }

  }, [sectionItems])

  return sectionItems && (
    <div className="section-container w-full h-full py-[50px] xs:py-[70px] sm:py-[120px] xl:px-[120px]">
      <div className={`w-full h-full grid grid-cols-1 s:grid-cols-2 ${sectionItems.length > 4 ? 'md:grid-cols-3' : 'md:grid-cols-4'} gap-[30px] fhd:gap-y-[45px] fhd:gap-x-[75px]`}>
        {sectionItems &&
          sectionItems.map((data, index) => {
            const { title, summary } = data?.article_language;
            const { file_small, description } = data?.assets[0];

            return (
              <div key={data.id} className="card w-full">
                <div  className={`w-full space-y-2 ${titleHeightCheck ? 'min-h-[80px]' : 'h-fit'}`}>
                  <div className='flex justify-center'>
                    <img className="max-w-[30px] max-h-[30px]" src={file_small} alt={description} />
                  </div>
                  <div className="title w-full">
                    <h1>{title}</h1>
                  </div>
                </div>
                <div className="detail w-full">
                  <p>{summary}</p>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default SSoft_Solutions_Detail_Card;
